import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import commonEN from '../locales/en/common.json';
import landingEN from '../locales/en/landing.json';
import dashboardEN from '../locales/en/dashboard.json';

import commonES from '../locales/es/common.json';
import landingES from '../locales/es/landing.json';
import dashboardES from '../locales/es/dashboard.json';

// Define the resources type for type safety
export const resources = {
  en: {
    common: commonEN,
    landing: landingEN,
    dashboard: dashboardEN,
  },
  es: {
    common: commonES,
    landing: landingES,
    dashboard: dashboardES,
  },
} as const;

// Initialize i18next
i18n
  .use(LanguageDetector) // Detects user language
  .use(initReactI18next) // Passes i18n instance to react-i18next
  .init({
    resources,
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: ['common', 'landing', 'dashboard'],

    interpolation: {
      escapeValue: false, // React already escapes values
    },

    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'loglimit-language',
    },

    react: {
      useSuspense: false,
    },
  });

export default i18n;
